import { useEffect } from 'react';
import supabase from '../../supabase/supabase';
import { reportImageStoragePath } from '../../utils/reportImagePath';

const ALREADY_PRIVATE_MARKERS = [
  '/storage/v1/object/sign/report-images/',
  '/storage/v1/object/authenticated/report-images/',
];

export default function PrivateReportImageBridge() {
  useEffect(() => {
    let disposed = false;
    const inFlight = new WeakSet();

    const signImage = async (img) => {
      if (!(img instanceof HTMLImageElement) || inFlight.has(img)) return;
      // getAttribute preserva o path relativo original; img.src/currentSrc já
      // podem ter sido resolvidos pelo navegador para uma URL do app.
      const source = img.getAttribute('src') || img.currentSrc || img.src;
      if (ALREADY_PRIVATE_MARKERS.some((marker) => String(source || '').includes(marker))) return;
      const path = reportImageStoragePath(source);
      if (!path) return;
      inFlight.add(img);
      try {
        const { data, error } = await supabase.storage.from('report-images').createSignedUrl(path, 3600);
        if (!disposed && !error && data?.signedUrl) img.src = data.signedUrl;
      } finally {
        inFlight.delete(img);
      }
    };

    const scan = (root = document) => {
      if (root instanceof HTMLImageElement) signImage(root);
      root.querySelectorAll?.('img[src]').forEach(signImage);
    };

    scan();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') scan(mutation.target);
        mutation.addedNodes.forEach((node) => node.nodeType === 1 && scan(node));
      }
    });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src'] });

    return () => {
      disposed = true;
      observer.disconnect();
    };
  }, []);

  return null;
}
